import Swiper, { Autoplay, Navigation } from 'swiper'
import 'swiper/css/bundle'

new Swiper('.swiper--top', {
  modules: [Autoplay, Navigation],
  loop: true, // ループ有効
  slidesPerView: 2, // 一度に表示する枚数
  allowTouchMove: true, // スワイプ無効
  speed: 1000,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
  // autoplay: {
  //   delay: 0 // 途切れなくループ
  // },
  breakpoints: {
    // スライドの表示枚数：600px以上の場合
    700: {
      slidesPerView: 3
    },
    // スライドの表示枚数：1080px以上の場合
    1080: {
      slidesPerView: 5
    }
  }
})
